export const MATRICE_CRITICITE = Object.freeze({
  1: Object.freeze({ 1: "mineure", 2: "mineure", 3: "mineure", 4: "mineure" }),
  2: Object.freeze({ 1: "mineure", 2: "mineure", 3: "majeure", 4: "majeure" }),
  3: Object.freeze({ 1: "majeure", 2: "majeure", 3: "majeure", 4: "critique" }),
  4: Object.freeze({ 1: "critique", 2: "critique", 3: "critique", 4: "critique" }),
});

export const CRITICITE_PRESENTATIONS = Object.freeze({
  critique: Object.freeze({ color: "#b91c1c", label: "🔴 Critique" }),
  majeure: Object.freeze({ color: "#b45309", label: "🟠 Majeure" }),
  mineure: Object.freeze({ color: "#166534", label: "🟢 Mineure" }),
});

export const calculerCriticite = (gravite, frequence) => {
  if (
    !Number.isInteger(gravite) ||
    !Number.isInteger(frequence) ||
    gravite < 1 ||
    gravite > 4 ||
    frequence < 1 ||
    frequence > 4
  ) {
    throw new Error(
      "La gravité et la fréquence doivent être des entiers compris entre 1 et 4."
    );
  }

  return MATRICE_CRITICITE[gravite][frequence];
};
